module.exports = __webpack_public_path__ + "static/media/gallery-white.429a5ed3.svg";